<template>
  <div class="ditemSelect">
    <div class="top flex-ac flex-sb">
      <div class="flex-ac scroll" style="width: calc(100% - 400px)">
        <div
          class=""
          @click="tagsClick({ label: '全部', value: '' })"
          :class="tagsOn == '' ? 'tagsOn' : ''"
        >
          全部
        </div>
        <div
          class=""
          v-for="(it, i) in tags"
          :key="i"
          @click="tagsClick(it, i)"
          :class="tagsOn == it.value ? 'tagsOn' : ''"
        >
          {{ it.label }}
        </div>
      </div>
      <div class="flex-ac">
        <el-input
          v-model="fiterLabel"
          size="mini"
          placeholder="请输入内容"
          v-show="fiterLabelShow"
          @blur="fiterLabelShowFunc(false)"
          ref="fiterLabelInput"
          clearable
        />
        <i
          class="el-icon-search"
          style="font-size: 16px; color: rgba(64, 158, 255, 1); cursor: pointer"
          @click="fiterLabelShowFunc(true)"
        />
      </div>
    </div>
    <div class="cen scroll">
      <template v-for="(it, i) in select">
        <div class="list" :key="i" v-if="it.show">
          <div
            @click="listClick(it, i)"
            class="flex-ac"
            :class="it.click ? 'listOn' : ''"
          >
            <el-tooltip
              class="item"
              effect="light"
              placement="top-start"
              :enterable="false"
              :open-delay="500"
            >
              <span v-html="it.label"></span>
              <div slot="content">
                <p class="parentsTooltip1" v-html="it.label"></p>
                <p
                  class="parentsTooltip2"
                  v-if="
                    it.attributes.ParentStations &&
                    it.attributes.ParentStations.length > 0
                  "
                >
                  <span
                    v-for="(item, p) in it.attributes.ParentStations"
                    v-html="item.label"
                  >
                    <i v-if="p < it.attributes.ParentStations.length - 1">/</i>
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </template>
    </div>
    <div class="bottom flex-ac flex-sb">
      <div>
        <el-button size="mini" @click="allClick(true)">全选</el-button>
        <el-button size="mini" @click="allClick(false)">取消全选</el-button>
        <!-- <template v-if="!sum">
          <el-button size="mini" @click="allClick(true)">全选</el-button>
          <el-button size="mini" @click="allClick(false)">取消全选</el-button>
          <span style="margin-left: 5px; color: #999; font-size: 12px">
            (已选中：{{ selectLength }}个{{ stationTabs[defaultType] }})
          </span>
        </template>
        <template v-else>
          <span style="margin-left: 5px; color: #999; font-size: 12px"
            >限选{{ sum }}个{{ stationTabs[defaultType] }}</span
          >
          <el-button v-if="sum > 1" size="mini" @click="allClick(false)"
            >取消选择</el-button
          >
        </template> -->
      </div>
      <div>
        <el-button size="mini" type="primary" @click="submit(false)"
          >确认</el-button
        >
        <el-button size="mini" @click="close">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["sum", "defaultDItems", "tags", "select", "exe"],
  components: {},
  computed: {
    ...mapGetters([""]),
  },
  data() {
    return {
      top_list: [],
      tagsOn: "",
      fiterLabelShow: "",
      fiterLabel: "",
    };
  },
  watch: {
    fiterLabel() {
      this.filterData();
    },
  },
  mounted() {
    this.select.map((v) => {
      this.defaultDItems.indexOf(v.value) > -1;
      this.$set(v, "click", this.defaultDItems.indexOf(v.value) > -1);
    });
    this.submit(false);
  },
  methods: {
    tagsClick(it) {
      this.tagsOn = it.value;
      this.filterData();
      this.selectLength = this.select.filter((v) => v.click).length;
    },
    fiterLabelShowFunc(flag) {
      if (!flag) {
        if (this.fiterLabel == "") {
          this.fiterLabelShow = false;
          this.filterData();
        } else {
          this.fiterLabelShow = true;
        }
      } else {
        this.fiterLabelShow = true;
        this.$nextTick(() => {
          this.$refs.fiterLabelInput.focus();
        });
      }
    },
    listClick(it, i) {
      if (this.sum == 1) {
        this.select.map((v) => {
          v.click = false;
        });
        this.$set(this.select[i], "click", !it.click);
        setTimeout(() => {
          this.submit(false);
        }, 0);
      } else {
        this.$set(this.select[i], "click", !it.click);
        if (this.select.filter((v) => v.click).length > this.sum) {
          this.$notify({
            position: "bottom-right",
            title: "提示",
            message: `当前最多可选${this.sum}个`,
            type: "info",
          });
          this.$set(this.select[i], "click", !it.click);
          return;
        }
      }
      this.selectLength = this.select.filter((v) => v.click).length;
      this.filterData();
    },
    allClick(flag) {
      this.select.map((v) => {
        if (v.show) v.click = flag;
      });
      this.selectLength = this.select.filter((v) => v.click).length;
      this.filterData();
    },
    submit(flag) {
      let ids = [],
        labels = [];
      this.select.map((v) => {
        if (v.click) {
          ids.push(v.value);
          labels.push(v.label);
        }
      });
      // if (this.tabsOn.path == "dataQuery") {
      //   this.$bus.$emit(
      //     "dataQueryStationClick",
      //     this.select.filter((v) => v.click)
      //   );
      // }
      this.$emit("ditemsSubmit", { ids, labels });
      if (!flag) {
        this.$parent.$parent.dItemsPopover = false;
      }
    },
    filterData() {
      let fiterLabel = this.fiterLabel.split("");
      for (var i = 0; i < fiterLabel.length; i++) {
        if (fiterLabel[i].charAt() >= "A" && fiterLabel[i].charAt() <= "z") {
          fiterLabel[i] = fiterLabel[i].toLowerCase();
        }
      }
      fiterLabel = fiterLabel.join("");
      let names = [];
      let reg = /<[^>]+>/gim;
      this.select.map((v, i) => {
        let label = v.label.split(reg).join("").split("");
        for (var i = 0; i < label.length; i++) {
          if (label[i].charAt() >= "A" && label[i].charAt() <= "z") {
            label[i] = label[i].toLowerCase();
          }
        }
        label = label.join("");
        if (
          (this.tagsOn == "" || v.attributes.Tags.indexOf(this.tagsOn) > -1) &&
          (fiterLabel == "" || label.indexOf(fiterLabel) > -1)
        ) {
          this.$set(v, "show", true);
        } else {
          this.$set(v, "show", false);
        }
      });
    },
    close() {
      if (this.$parent.$parent.dItemsPopover)
        this.$parent.$parent.dItemsPopover = false;
      if (this.$parent.$parent.$parent.dItemsPopover)
        this.$parent.$parent.$parent.dItemsPopover = false;
      if (this.$parent.$parent.$parent.$parent.dItemsPopover)
        this.$parent.$parent.$parent.$parent.dItemsPopover = false;
      if (this.$parent.$parent.$parent.$parent.$parent.dItemsPopover)
        this.$parent.$parent.$parent.$parent.$parent.dItemsPopover = false;
      if (this.$parent.$parent.$parent.$parent.$parent.$parent.dItemsPopover)
        this.$parent.$parent.$parent.$parent.$parent.$parent.dItemsPopover = false;
    },
  },
  destroyed() {},
};
</script>
<style lang="stylus">
.ditemsSelectPopover {
  width: max-content !important;
  height: max-content !important;
  padding: 0 !important;
}

.ditemSelect {
  width: 1000px;
  height: 400px;
  background: #fff;
  box-sizing: content-box;

  .right {
    width: 450px;
    height: 100%;
  }

  .top {
    width: 100%;
    height: 35px;
    padding: 0 15px;

    >div {
      width: max-content;

      >div {
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-right: 20px;
        cursor: pointer;
        line-height: 30px;
        white-space: nowrap;
      }
    }

    .tagsOn {
      color: rgba(17, 130, 251, 1);
      position: relative;

      &:after {
        position: absolute;
        content: '';
        display: block;
        width: 12px;
        height: 3px;
        border-radius: 2px;
        background: rgba(64, 158, 255, 1);
        bottom: 0%;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }

    .el-input {
      width: 150px;
      height: 26px;
      line-height: 26px;

      .el-input__inner {
        width: 150px;
        height: 26px;
        line-height: 26px;
      }
    }
  }

  .cen {
    width: 100%;
    height: calc(100% - 35px - 50px);
    border-top: 1px solid rgba(240, 240, 240, 1);
    border-bottom: 1px solid rgba(240, 240, 240, 1);
    padding: 5px;
  }

  .bottom {
    width: 100%;
    height: 50px;
    padding: 0 10px;
  }

  .el-button {
    height: 26px;
    line-height: 26px;
    padding: 5px 12px;
  }

  h1 {
    padding-left: 1em;
  }

  h2 {
    padding-left: 2em;
  }

  h3 {
    padding-left: 3em;
  }

  h4 {
    padding-left: 4em;
  }

  h1, h2, h3, h4 {
    cursor: pointer;
    line-height: 18px;
    display: inline-flex;
    align-items: center;

    input {
      margin-right: 4px;
    }
  }

  .list {
    width: 16.6%;
    padding: 2px 10px;
    height: max-content;
    display: inline-block;

    div {
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(229, 229, 229, 1);
      padding: 6px 10px;
      height: 26px;
      font-size: 12px;
      width: 100%;
      position: relative;
      cursor: pointer;
      color: #666;

      span {
        position: absolute;
        left: 6px;
        top: 50%;
        right: 6px;
        transform: translate(0, -50%);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
      }
    }
  }

  .listOn {
    color: rgba(17, 130, 251, 1) !important;
    background: rgba(64, 158, 255, 0.1) !important;
    border: 1px solid rgba(17, 130, 251, 0.8) !important;
  }

  .el-icon-arrow-right {
    transition: 0.2s;
    cursor: pointer;
  }

  .el-button+.el-button {
    margin-left: 5px;
  }

  .el-button {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/selectDitems.vue